import { createContext, useContext } from "react";

export const OnlineStatusContext = createContext(null);

export const useOnlineStatusContext = () => {
  const ctx = useContext(OnlineStatusContext);
  if (!ctx) throw new Error("useOnlineStatusContext must be used inside provider");
  return ctx;
};
